import { TCreateConsultingRequestResponse_1 } from '../../repositories/newbuilding-flat-view-order/v2/create-consulting-request';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EHhActionTypes {
  SetHhConversionId = 'hh/SET_HH_CONVERSION_ID',
}

export type TSetHhConversionId = ITypedReduxAction<
  EHhActionTypes.SetHhConversionId,
  TCreateConsultingRequestResponse_1
>;

export const setHhConversionId = actionGenerator<EHhActionTypes.SetHhConversionId, TCreateConsultingRequestResponse_1>(
  EHhActionTypes.SetHhConversionId,
);

export type THhStatusAction = TSetHhConversionId;
